module.exports = __webpack_public_path__ + "static/media/tapingo@2x.f6e7b379.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/tapingo@2x.png
// module id = 92
// module chunks = 0